import React, { useEffect } from 'react';
import ContactInfo from '../components/common/ContactInfo';
import ContactForm from '../components/common/Form/ContactForm';
import SocialLinks from '../components/common/SocialLinks';
import { setDefaultSEO } from '../utils/seoUtils';
import './Contact.css';


function Contact() {
  // Set default SEO for contact page
  useEffect(() => {
    setDefaultSEO('Contact');
  }, []);


  const handleSubmit = (formData) => {
    // Handle form submission logic here
    console.log(formData);
  };

  return (
    <div className="contact-page">
      {/* SEO Meta Tags - Set via setDefaultSEO in useEffect */}
      
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>Get in touch with us for any queries or support</p>
      </div>

      <div className="container">
        <div className="contact-content">
          <ContactInfo />
          <ContactForm onSubmit={handleSubmit} />
        </div>
        <SocialLinks />
      </div>
    </div>
  );
}

export default Contact; 